import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';
import { GlobalService } from './global.service';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { AppUrl } from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService{

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,) {
    super(http, alertService, globalService);
  }

  sentNotificationInvigilator(data: any): Observable<any>{
    return this.getRequest(AppUrl.SENT_NOTIFICATION_INVIGILATOR(), data);
  }

  sendToStudent(data: any): Observable<any>{
    return this.postRequest(AppUrl.SEND_TO_STUDENT(), data);
  }

  aiNotifications(data: any): Observable<any>{
    return this.getRequest(AppUrl.AI_NOTIFICATION(), data);
  }

  cheatNotificationMarkRead(data: any = {}): Observable<any>{
    return this.putRequest(AppUrl.CHEAT_NOTIFICATION_MARK_READ(), data);
  }

  sendGeneralNotification(data: any): Observable<any>{
    return this.postRequest(AppUrl.SEND_GENERAL_NOTIFICATION(), data);
  }

  generalNotificationMarkRead(data: any = {}): Observable<any>{
    return this.putRequest(AppUrl.GENERAL_NOTIFICATION_MARK_READ(), data);
  }

  list(data: any = {}): Observable<any>{
    return this.getRequest(AppUrl.GENERAL_NOTIFICATION_LIST(), data);
  }

  sentByOrganisation(data: any = {}): Observable<any>{
    return this.getRequest(AppUrl.SENT_NOTIFICATION_BY_ORG(), data);
  }


}
